export default __webpack_public_path__ + "static/media/SFProDisplay-Regular.b089a1f9.otf";